module.exports = __webpack_public_path__ + "img/17fa0aa2f3d3ce5ff6308965b79baa9c.png";